export const ENROLLMENT_INTENTS = {
  PAYROLL_PARTNER: 'payrollPartner',
} as const

export const INTENT_TYPES = {
  // Used in Change Address flow to generate Set Pin flow link
  ENROLL: 'enroll',
  // Used in Card Enrollment flow and Replace Card flow (Reissue Card)
  PAYROLL_PARTNER: ENROLLMENT_INTENTS.PAYROLL_PARTNER,
  // Used in Edit Funding flow, Set Pin flow, and Replace card flow after Request Physical Card with Fee intro page redirect
  REQUEST_PHYSICAL_CARD_WITH_FEE: 'requestPhysicalCardWithFee',
  REQUEST_PHYSICAL_CARD: 'requestPhysicalCard',
  // Used in Set Pin flow
  SHOW_CARD: 'showCard',
} as const

export type EnrollmentIntent = (typeof ENROLLMENT_INTENTS)[keyof typeof ENROLLMENT_INTENTS]
export type IntentType = (typeof INTENT_TYPES)[keyof typeof INTENT_TYPES]
